import { ReactElement } from 'react'
import { KEYWORD_OUTER_CHILDREN, VALID_OUTER_CHILDREN } from '../Panes/types-and-constants/LayoutPaneTypesAndConstants'

/**
 * @param children - children of Layout component
 * @returns - children that are valid children to be delegated to the OuterLayout partial
 *
 * filters out children that don't have the keyword in their paneType that identifies them as valid outer children
 * filters out children that don't have a paneType that matches the required paneCategories
 * */
export const getOuterChildren = (children: ReactElement[]): ReactElement[] => {
    let validOuterChildren: ReactElement[] =
        children.filter((child) => {
            console.assert(child?.props?.paneType, 'child is not a LayoutPane')
            if (!child?.props?.paneType) {
                return false
            }

            const containsRequiredKeyword: boolean = child?.props?.paneType?.includes(KEYWORD_OUTER_CHILDREN)
            const isOfValidCategory: boolean = VALID_OUTER_CHILDREN.some((keyword: string) => {
                return child?.props?.paneType?.includes(keyword)
            })

            return containsRequiredKeyword && isOfValidCategory
        }) ?? []

    return validOuterChildren
}

export default getOuterChildren
